import React, { FC } from "react";

import { Box, Icon } from "../ui";

import styles from "./index.module.css";

type StubBoxProps = {
  message: string;
};

const StubBox: FC<StubBoxProps> = (props) => {
  const { message } = props;

  return (
    <Box className={styles.container}>
      <div className={styles.content}>
        <div>
          <Icon name="Info" size={74} />
        </div>
        <div className={styles.message}>{message}</div>
      </div>
    </Box>
  );
};

export default StubBox;
